<template>
  <div>
    <BAsyncAutocompleteCommon
      v-if="!readonly"
      :$type="typeAutocomplete"
      :value="value"
      :return-object="returnObject"
      v-on="$listeners || {}"
      @action:append="onActionAppend"
    />
    <slot v-else name="header" />

    <div style="margin: 0 -16px -8px;">
      <BTableCommon
        v-bind="$attrs"
        :type="typeTable"
        :list="value"
        :name="name"
        :actions="readonly ? [] : actions"
        :headers="headers"
        v-on="$listeners || {}"
        @action:delete="onActionDelete"
      />
    </div>
  </div>
</template>

<script>
import BTableCommon from '@/components/tables/BTableCommon.vue'
import BAsyncAutocompleteCommon from '@/components/forms/BAsyncAutocompleteCommon.vue'
import uniqueId from 'lodash/uniqueId'

export default {
  name: 'BTableWithAutocompleteAsync',
  components: {
    BTableCommon,
    BAsyncAutocompleteCommon,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: uniqueId('b-table-with-autocomplete-async'),
    },
    typeAutocomplete: {
      type: String,
      // required: true,
    },
    typeTable: {
      type: String,
      required: true,
    },
    actions: Array,
    headers: Array,
    readonly: Boolean,
    returnObject: Boolean,
  },
  methods: {
    onActionAppend(data) {
      if (!data) return
      this.$emit('input', [].concat(this.value, data))
      this.$emit('append', data)
    },
    onActionDelete(data) {
      const value = Array.isArray(this.value) ? this.value.slice() : []
      const index = value.indexOf(data)
      if (index !== -1) {
        value.splice(index, 1)
        this.$emit('input', value)
        this.$emit('remove', data)
      }
    },
  },
}
</script>
